import React, { useEffect, useState, useContext, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';
import { UserContext } from '../contexts/userContext';
import request from '../services/Request';
import EnterEmail from './enterEmail';
import TW_log from '../machineUI/NaviBar/icons/travel-wifi-logo.png';
import localRequest from '../services/LocalServer/localRequest';
import IdleEmail from './items/IdleEmail';
import Cookies from 'js-cookie';

const createOrderURL = `/orders/create`;
const oneTimeStatus = '/promos/status/';

export default function ProductDispense(props) {
  const isLocal = localStorage.getItem('ISLOCAL') === 'TRUE';
  const { testMode } = useContext(UserContext);
  const { stat, setStat, linkPromo } = props;
  const machine = JSON.parse(localStorage.getItem('machine'));
  const currency = machine?.currency?.code;
  // const FinalProducts = JSON.parse(localStorage.getItem('FinalProducts'));

  const { receipt, belongTo, name } = machine;

  const { t } = useTranslation();
  let history = useHistory();
  const machineID = props.id;
  const [inv, setInv] = useState(() => {});
  const [failOne, setFailOne] = useState(false);
  const [show, setShow] = useState(false);
  const [inputShow, setInputShow] = useState(false);
  const [door, setDoor] = useState(t('Your items are vending, please wait.'));
  const countRef = useRef(0);
  const [receiptSend, setReceiptSend] = useState(false);
  const [readySend, setReadySend] = useState(false);
  const [orderID, setOrderID] = useState('');
  const [showProduct, setShowProduct] = useState(true);
  const [error, setError] = useState('');
  const [input, setInput] = useState('');
  const [isCheck, setCheck] = useState(true);
  const [messageWidth, setMessageWidth] = useState('78.4%');
  const [go, setGo] = useState(false);
  const [credit, setCredit] = useState(0);

  let p = JSON.parse(localStorage.getItem('SeparateItem'));
  p = p.filter((e) => e.prodType === 'prod');

  let [FinalTax, setFinalTax] = useState(parseFloat(localStorage.getItem('FinalTax')));
  let [TotalPrice, setTotalPrice] = useState(parseFloat(localStorage.getItem('TotalPrice')));
  const [separateItem, setP] = useState(p);

  const [pod, setPods] = useState([...separateItem, { item_id: 0 }]);

  const cartProds = separateItem.map((prod, i) => {
    // console.log(prod);
    // const url = `${process.env.REACT_APP_SERVER_API}/pictures/${prod.picture}/${prod.referTo}`;
    const url = isLocal
      ? `${process.env.REACT_APP_LOCAL_API}/pictures/products/${prod.picture}`
      : `${process.env.REACT_APP_SERVER_API}/pictures/${prod.picture}/${prod.referTo}`;
    return (
      <div className="payment-product-card" key={i}>
        <img className="card-img" src={url} alt=""></img>
        <div className="payment-card-text">{prod.product_name}</div>
      </div>
    );
  });

  useEffect(() => {
    if (!testMode) {
      var interval = setInterval(() => fetchAPI(), 1000);
      setInv(interval);
      return () => {
        clearInterval(interval);
      };
    }
  }, []);

  async function fetchAPI() {
    // console.log('TotalPrice', TotalPrice);
    await localRequest({
      method: 'get',
      url: `${process.env.REACT_APP_LOCAL_API}/dispenseStatus/${pod[countRef.current].item_id}`,
    }).then(async (status) => {
      if (status.data.status === 'SUCCESS') {
        const index = pod.findIndex((e) => e.item_id === status.data.item_id);
        if (index > -1 && pod[index].status !== 'SUCCESS') {
          pod[index].status = 'SUCCESS';
          setPods([...pod]);
          countRef.current = countRef.current + 1;
          setDoor(t('Your items are vending, please wait.'));
          setMessageWidth('78.4%');
        }
      } else if (status.data.status === 'FAIL') {
        setFailOne(true);
        const index = pod.findIndex((e) => e.item_id === status.data.item_id);
        if (index > -1 && pod[index].status !== 'FAIL') {
          //adjust transaction if failed
          const indexFinal = separateItem.findIndex((e) => e.item_id === status.data.item_id);
          // console.log(indexFinal);
          if (indexFinal > -1) {
            FinalTax = parseFloat((FinalTax - separateItem[indexFinal].tax_amount).toFixed(2));
            TotalPrice = parseFloat(
              (TotalPrice - separateItem[indexFinal].total_amount).toFixed(2)
            );
            // setFinalTax(newTax);
            // setTotalPrice(...newPrice);
            separateItem[indexFinal].err = true;
            setFinalTax(FinalTax);
            setTotalPrice(TotalPrice);
          }
          pod[index].status = 'FAIL';
          setPods([...pod]);
          countRef.current = countRef.current + 1;
        }
        setDoor(t('Your items are vending, please wait.'));
        setMessageWidth('78.4%');
      } else if (status.data.status === 'CHANGE') {
        setDoor(t('Please collect change'));
        setMessageWidth('82%');
      } else if (status.data.status === 'COMPLETED') {
        setCredit(status.data.credit);
        await clearInterval(inv);
        setShowProduct(true);
        setDoor(t('Thank you for shopping at TravelWifi Express!'));
        setMessageWidth('72.4%');
        await setTimeout(
          () => {
            setGo(true);
          },
          receiptSend ? 1000 : 5000
        );
      } else if (status.data.status === 'TAKE') {
        setDoor(t('Please grab your product'));
        setMessageWidth('82%');
      }
    });
  }

  // useEffect(async () => {
  //   if (!testMode) {
  //     let go = pod.every((a) => a.status === 'SUCCESS');
  //     let failGo = pod.every((a) => a.status === 'SUCCESS' || a.status === 'FAIL');
  //     if (go || failGo) {
  //       await clearInterval(inv);
  //       setShowProduct(true);
  //       setDoor(t('Thank you for shopping at TravelWifi Express!'));
  //       setMessageWidth('72.4%');
  //       await setTimeout(
  //         () => {
  //           setGo(true);
  //         },
  //         receiptSend ? 1000 : 5000
  //       );
  //     }
  //   } else {
  //     // history.push(linkToURL + 'true');
  //   }
  // }, [pod]);

  const updateStatus = async () => {
    await localRequest({
      method: 'post',
      url: `${process.env.REACT_APP_LOCAL_API}/updateKioskStatus`,
      data: { status: 'Active' },
    });
  };

  useEffect(async () => {
    const mycoockie = Cookies.get('i18next') ? Cookies.get('i18next') : 'en';

    if (go) {
      if (separateItem?.length > 0) {
        let status = failOne ? 'Failed' : 'Completed';
        //add banner convertion
        console.log('linkPromo', linkPromo);
        if (linkPromo?.id !== '') {
          const conIdx = separateItem.findIndex((e) => e.product === linkPromo?.id);
          if (conIdx > -1) {
            console.log('same');
            stat.banner.conv = 1;
            setStat(stat);
            console.log('stat', stat);
          }
        }
        // add prod conver
        separateItem.forEach((item) => {
          const prodIdx = stat.prod.findIndex((e) => e._id === item.product);
          if (prodIdx > -1) {
            stat.prod[prodIdx].conv += 1;
          }
        });

        console.log('separateItem?', separateItem);
        let date = new Date();
        let realTime = new Date();
        const offset = date.getTimezoneOffset();
        date.setTime(date.getTime() - offset * 60 * 1000);

        const linkToURL = `/machineUI/home/${machineID}/`;

        const orderData = {
          machine: machineID,
          products: separateItem,
          tax: FinalTax,
          belongTo: belongTo,
          total: TotalPrice,
          machineName: name,
          currency: currency,
          createdAt: date,
          realTime: realTime,
          isCheck: isCheck,
          status: status,
          credit: credit,
          email: receiptSend ? input : '',
          payment_type: localStorage.getItem('payment_type'),
          id: name + new Date().getTime(),
          lang: mycoockie,
          send_order_third: localStorage.getItem('send_order_third'),
        };

        console.log('orderData', orderData);

        await request({
          method: 'post',
          url: createOrderURL,
          data: orderData,
          timeout: 3800,
        })
          .then((res) => {
            console.log('sendorder to remote success', res.data);
            setOrderID(res.data.order._id);
            setReadySend(true);
          })
          .catch(() => {
            console.log('sendorder to local');
            localRequest({
              method: 'post',
              url: createOrderURL,
              data: orderData,
            }).then((res) => {
              console.log('send order to local succcess', res.data);
              setOrderID(res.data?.order?._id);
              setReadySend(true);
            });
          });

        const oneTime = JSON.parse(localStorage.getItem('oneTime'));
        if (oneTime) {
          for (let i = 0; i < oneTime.length; i++) {
            await request({
              method: 'patch',
              url: oneTimeStatus + oneTime[i]._id,
              data: {
                active: false,
              },
            }).then((res) => {
              console.log('one time promotion has been expired');
            });
          }
        }
      }
    }
  }, [go]);

  useEffect(async () => {
    if (go) {
      if (!testMode) {
        await setTimeout(async () => {
          if (!show) {
            stat.session_com = 1;
            setStat(stat);
            history.push(`/machineUI/slider/${machineID}`);
          }
        }, 4000);
      } else {
        // history.push(linkToURL + 'true');
      }
    }
  }, [go, receiptSend, show]);

  const setKeyBoardShow = () => {
    setInputShow(true);
    setShow(true);
  };

  const submitEmail = () => {
    if (error === '' && input !== '') {
      setShow(false);
      setReceiptSend(true);
    } else {
      const myfocus = document.getElementById('email-enter-input');
      myfocus.focus();
      console.log(myfocus);
    }
    if (input === '') {
      setError(t('Email address can not be empty.'));
    }
  };

  return (
    <div className="payment-container">
      <IdleEmail go={go} />
      <div className="payment-container-div">
        {showProduct && (
          <div>
            <img className="payment-logo-img" src={TW_log} alt=""></img>
            <div className="payment-products-container">{cartProds}</div>
            <div className="payment-line"></div>
          </div>
        )}
        {failOne ? (
          <div
            className={showProduct ? 'dispense-title' : 'dispense-title-none'}
            style={{ marginTop: '-40px', fontSize: '60px' }}
          >
            {t(`You will not be charged for products not vended.`)}

            <p style={{ marginTop: '80px' }}>{door}</p>
          </div>
        ) : (
          <div
            className={showProduct ? 'dispense-title' : 'dispense-title-none'}
            style={{ width: messageWidth }}
          >
            {door}
          </div>
        )}

        {inputShow && receiptSend ? (
          readySend ? (
            <div className="dispense-get-receipt-text">{t(`Delivering receipt...`)}</div>
          ) : (
            <div className="dispense-get-receipt-text">{t(`Delivering receipt...`)}</div>
          )
        ) : (
          !inputShow &&
          !go &&
          navigator.onLine &&
          receipt && (
            <div className="view-more-button dispense-get-receipt-button" onClick={setKeyBoardShow}>
              {t(`GET RECEIPT`)}
            </div>
          )
        )}
        <EnterEmail
          isLocal={isLocal}
          isCheck={isCheck}
          setCheck={setCheck}
          receipt={receipt}
          receiptSend={receiptSend}
          langs={props.langs}
          cart={props.cart}
          showProduct={showProduct}
          orderID={orderID}
          setReceiptSend={setReceiptSend}
          readySend={readySend}
          inputShow={inputShow}
          id={machineID}
          testMode={props.testMode}
          show={show}
          setShow={setShow}
          setError={setError}
          error={error}
          input={input}
          setInput={setInput}
          separateItem={separateItem}
        />
        {inputShow && !receiptSend && receipt && (
          <div className="d-flex justify-content-center">
            <div className="view-more-button dispense-get-receipt-button-2" onClick={submitEmail}>
              {t(`GET RECEIPT`)}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
